module.exports = __webpack_public_path__ + "img/17.20744482.jpg";